import React from "react";
import { Row, Col, Form, Input, Typography, Alert, Card, Space } from "antd";
import { useTranslation } from "react-i18next";
import { FileTextOutlined } from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

export function EvaluationWizardStep2Identity({ subtype }) {
  // "Descripcion" ya existe en common: no se duplica en este namespace.
  const { t } = useTranslation(["evaluations", "common"]);

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={16}>
          <Title level={5} style={{ marginTop: 0 }}>
            {t("asistente.paso2.titulo")}
          </Title>

          <Alert
            type="info"
            showIcon
            message={t("asistente.paso2.comoRedactarlo")}
            description={
              <div>
                <div>{t("asistente.paso2.consejoTitulo")}</div>
                <div>{t("asistente.paso2.consejoDescripcion")}</div>
              </div>
            }
            style={{ marginBottom: 12 }}
          />

          <Form.Item
            label={t("campos.titulo")}
            name="title"
            rules={[
              {
                required: true,
                message: t("asistente.validacion.tituloObligatorio"),
              },
              { min: 3, message: t("asistente.validacion.min3") },
              { max: 80, message: t("asistente.validacion.max80") },
            ]}
          >
            <Input placeholder={t("asistente.paso2.placeholderTitulo")} />
          </Form.Item>

          <Form.Item
            label={t("common:fields.description")}
            name="description"
            rules={[{ max: 280, message: t("asistente.validacion.max280") }]}
          >
            <Input.TextArea
              rows={4}
              placeholder={t("asistente.paso2.placeholderDescripcion")}
              showCount
              maxLength={280}
            />
          </Form.Item>
        </Col>

        <Col xs={24} lg={8}>
          <Card
            className="revi-eval-wizard__previewCard"
            variant="outlined"
            size="small"
            title={
              <Space size={8}>
                <FileTextOutlined />
                <Text strong>{t("asistente.paso2.formatoElegido")}</Text>
              </Space>
            }
          >
            <Paragraph style={{ marginBottom: 0 }} type="secondary">
              {t("asistente.paso2.subtipoEtiqueta")} <b>{subtype}</b>
            </Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
